<template>
  <div class="view-image-group">
    <img :src="imagePath" class="view-image" @click="closePanel">
  </div>
</template>

<script>
export default {
  name: "ImageViewer",
  props: ['imagePath'],
  mounted() {
    window.callbackBackKey = this.callbackBackKey;
  },
  methods : {
    closePanel(){
      this.$emit("closePanel")
    },
    // APP 뒤로가기
    callbackBackKey(){
      this.closePanel()
    },
  }
}
</script>

<style scoped>
.view-image-group{
  text-align: center;
}
.view-image {
  width: 100%;
}
</style>